export default "__VITE_ASSET__4ffcf7c9__"